import React, { MouseEvent, useEffect } from 'react'
import { Button } from "@mui/material";
import { BackgroundColor } from 'devextreme-react/cjs/linear-gauge';

interface Props {
    text: string
    color: string | undefined
    onClick: (e?: MouseEvent<HTMLButtonElement>) => void
    disabled: boolean
}

const FullWidthMobileButton: React.FC<Props> = ({ text, color, onClick, disabled }) => {




    return (
        <>
            {color === '#e0e0e0' ?
                <Button
                    variant="contained"

                    style={{
                        width: "100%",
                        padding: "6px 20px",
                        fontSize: "22px"
                    }}
                    onClick={(e: MouseEvent<HTMLButtonElement>): void => onClick(e)}
                    disabled={disabled}
                    sx={{ backgroundColor: color }}
                >
                    {text}
                </Button> :
                <Button
                    variant="contained"

                    style={{
                        width: "100%",
                        padding: "6px 20px",
                        fontSize: "22px"
                    }}
                    onClick={(e: MouseEvent<HTMLButtonElement>): void => onClick(e)}
                    disabled={disabled}
                    color={color}
                >
                    {text}
                </Button>}
        </>
    )
}
export default FullWidthMobileButton